/** @format */

export const columns = [
  {
    dataField: "fileName",
    text: "파일 이름",
    sort: true,
    align: "left",
    headerAlign: "center",
    style: {
      minWidth: "200px",
      fontSize: "13px",
      color: "#333",
      lineHeight: "1.7",
    },
    formatter: (cellContent) => {
      return <div className="truncate-2-lines">{cellContent}</div>;
    },
  },
];
